import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-x', 'LetterX', [["path",{"d":"M7 4l10 16","key":"svg-0"}],["path",{"d":"M17 4l-10 16","key":"svg-1"}]]);